import { AgGridReact } from "@ag-grid-community/react";
import columnBuilder from "common/agGrid/columnBuilder";
import defaultGridOptions from "common/agGrid/defaultGridOptions";
import RenderParameters from "common/agGrid/renderParameters";
import useColumnDefinitions from "common/agGrid/useColumnDefinitions";
import { getTraderDisplayName, Trader } from "features/settings/traders/trader";
import React from "react";

export interface TraderListProps {
    traders: Trader[];
    onTraderUpdated(trader: Trader): void;
    onTraderSelected(trader: Trader): void;
}

const TraderList: React.FC<TraderListProps> = (props) => {
    const hasMaxNonProUsers = props.traders.filter(m => m.isNonProUser).length >= 2;
    const columns = useColumnDefinitions(getColumns, [hasMaxNonProUsers])

    function getColumns() {
        return [
            columnBuilder.for("Name", null)
                .withGetter((params: any) => getTraderDisplayName(params.data))
                .withCellRenderer((params: RenderParameters<Trader>) => {
                return (
                    <button className="link-button" onClick={() => props.onTraderSelected(params.node.data)}>
                        {params.value}
                    </button>
            )})
            .build(),
            columnBuilder.for("Non-pro User?", "isNonProUser")
                .withCellRenderer<Trader>(params => 
                    <input type="checkbox"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => 
                            props.onTraderUpdated({
                                ...params.node.data, 
                                isNonProUser: event.target.checked
                        })}
                        disabled={!params.value && hasMaxNonProUsers}
                        checked={params.value} 
                    />)
                .build()
        ];
    }


    return <div className="ag-theme-alpine w-100" >
        <AgGridReact
            {...defaultGridOptions}
            columnDefs={columns}
            paginationPageSize= { 25 }
            pagination
            rowData={props.traders}
            getRowId={params => params.data.userId}
            domLayout="autoHeight"
        />
    </div>
}


export default TraderList;